$ = jQuery.noConflict();

$( document ).ready(function() {

      // jQuery('.wsg-proxy-container').next().html('<span>category</span>');

});





